import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Route } from "lucide-react";

const input = "w-full border border-slate-300 rounded-xl px-3 py-2 text-sm focus:border-gold outline-none disabled:opacity-50";

export function CoverageTravelCard() {
  const { user, refresh } = useAuth();
  const [f, setF] = useState(null);
  useEffect(() => {
    setF({ coverageMaxKm: user.coverageMaxKm ?? 100, coverageAllItaly: !!user.coverageAllItaly,
      travelIncludedKm: user.travelIncludedKm ?? 0, travelRatePerKm: user.travelRatePerKm ?? 0.4 });
  }, [user]);
  if (!f) return null;
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const save = async () => {
    if (f.travelRatePerKm === "" || Number(f.travelRatePerKm) < 0) { toast.error("Indica la tariffa al km (anche 0)"); return; }
    try { await api.patch("/me", { ...f, coverageMaxKm: Number(f.coverageMaxKm) || 0, travelIncludedKm: Number(f.travelIncludedKm) || 0, travelRatePerKm: Number(f.travelRatePerKm) }); toast.success("Raggio e trasferta salvati"); refresh(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="mt-8 card-premium p-6 space-y-4" data-testid="coverage-travel-card">
      <div className="flex items-center gap-2"><Route className="w-5 h-5 text-gold"/><h3 className="font-display text-xl font-bold">Raggio d'azione e trasferta</h3></div>
      <div className="grid md:grid-cols-3 gap-4 items-start">
        <label className="text-xs font-semibold text-slate-600">Raggio d'azione (km)
          <input data-testid="dash-coverageMaxKm" type="number" min={0} disabled={f.coverageAllItaly} value={f.coverageAllItaly ? "" : f.coverageMaxKm} placeholder={f.coverageAllItaly ? "Tutta Italia" : ""} onChange={(e) => set("coverageMaxKm", e.target.value)} className={`${input} mt-1`}/>
          <span className="flex items-center gap-2 mt-2 font-normal cursor-pointer"><input type="checkbox" data-testid="dash-coverageAllItaly" checked={f.coverageAllItaly} onChange={(e) => set("coverageAllItaly", e.target.checked)} className="accent-[#C98A3C]"/>Tutta Italia</span>
        </label>
        <label className="text-xs font-semibold text-slate-600">Km inclusi nel prezzo
          <input data-testid="dash-travelIncludedKm" type="number" min={0} value={f.travelIncludedKm} onChange={(e) => set("travelIncludedKm", e.target.value)} placeholder="es. 50" className={`${input} mt-1`}/></label>
        <label className="text-xs font-semibold text-slate-600">Tariffa al km oltre la soglia (€)
          <input data-testid="dash-travelRatePerKm" type="number" min={0} step="0.01" value={f.travelRatePerKm} onChange={(e) => set("travelRatePerKm", e.target.value)} placeholder="es. 0.40" className={`${input} mt-1`}/></label>
      </div>
      <p className="text-xs text-slate-500">Nel preventivo automatico: trasferta = (km A/R − {Number(f.travelIncludedKm) || 0} km inclusi) × €{Number(f.travelRatePerKm || 0).toFixed(2)}/km.</p>
      <button type="button" data-testid="dash-coverage-save" onClick={save} className="btn-pill-gold text-sm">Salva</button>
    </div>
  );
}
